<template>
  <a href="#" class="list-group-item pl-5" @click="switchUser()">
    <i class="far fa-user fa-fw"></i>{{ name }}
  </a>
  
</template>
<script>
import axios from "axios";
//let $ = JQuery
export default {
  name: 'UserButton',
  props: {
    name: String,
    user: null,
    is_group: true,
    accounts: []
  },
  data() {
    return {
      show_list: true,
      balance: 0
    }
  },
  methods: {
    switchUser() {
      this.$store.commit('switch_user', this.user)
      this.$store.dispatch('loadData')
    },
  },
  computed: {

  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-group-item {
  padding: 6px 10px
}

.pl-5 {
  padding-left: 2.2rem !important;
}
</style>
